import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import { withGilt, withTranslation } from 'providers/GILT.provider';
import { selectCurrentSalonCurrency } from 'selectors/currentSalon.selectors';

import PopupModalContainer from 'common/PopupModal';
import ReportTableV2 from 'reports/Common/ReportTableV2';
import BarChartD3 from 'reports/DashboardReports/BarChartD3';
import { makeMonthlyTable, ReportTablesMap, revenueByMonth } from 'reports/utils';

class RevenueByStylistMonthlyTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showPopup: true,
      revenueObj: null,
    };
  }

  componentDidMount() {
    this.chartWidth();
    window.addEventListener('resize', this.chartWidth);
    if (this.props.monthlyRevenueReport) {
      const revenueObj = revenueByMonth(this.props.monthlyRevenueReport.lastRequestResponse, this.props.selectedStylist, this.props.currency);
      const interval = setInterval(() => {
        if (revenueObj) {
          clearInterval(interval);
          this.setState({ revenueObj });
        }
      });
    }
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (
      nextProps.monthlyRevenueReport &&
      nextProps.monthlyRevenueReport.lastRequestResponse &&
      (nextProps.monthlyRevenueReport.start_date !== this.props.monthlyRevenueReport.start_date ||
        nextProps.monthlyRevenueReport.end_date !== this.props.monthlyRevenueReport.end_date ||
        moment(nextProps.lastMonthlyDatesSelected.toDate).toISOString() !== moment(this.props.lastMonthlyDatesSelected.toDate).toISOString() ||
        nextProps.selectedStylist !== this.props.selectedStylist)
    ) {
      this.setState({ revenueObj: null });
      const revenueObj = revenueByMonth(nextProps.monthlyRevenueReport.lastRequestResponse, nextProps.selectedStylist, nextProps.currency);
      const interval = setInterval(() => {
        if (revenueObj) {
          clearInterval(interval);
          this.setState({ revenueObj });
        }
      });
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.chartWidth);
  }

  closeModal = () => {
    this.setState({ showPopup: false });
  };
  chartWidth = () => {
    if (window.innerWidth >= 1024) {
      return 1024;
    }
    if (window.innerWidth >= 834) {
      return 800;
    }
    if (window.innerWidth >= 810) {
      return 780;
    }
    if (window.innerWidth >= 768) {
      return 700;
    }
    if (window.innerWidth >= 375) {
      return 360;
    }
    if (window.innerWidth <= 320) {
      return 300;
    }
    return 1023;
  };

  render() {
    const { revenueObj } = this.state;
    let dataArray = [];
    let totalTimeRange;
    const { currency, t, formatDate } = this.props;

    if (revenueObj) {
      dataArray = revenueObj.dataArray;
      totalTimeRange = revenueObj.totalTimeRange;
    }

    if (
      (!revenueObj || !dataArray.length) &&
      this.state.showPopup &&
      this.props.monthlyRevenueReport &&
      this.props.monthlyRevenueReport.lastRequestResponse &&
      !Object.keys(this.props.monthlyRevenueReport.lastRequestResponse).length
    ) {
      return (
        <PopupModalContainer
          popupTitle={t('businessReports.monthly.noDataPopupTitle')}
          popupMessage={t('businessReports.monthly.noDataPopupMessage')}
          buttonText={t('common.buttons.ok')}
          buttonCallback={this.closeModal}
        />
      );
    } else if (dataArray.length && totalTimeRange) {
      const revenueData = makeMonthlyTable(dataArray, ReportTablesMap.REVENUE, totalTimeRange.salonTotalRevenueTimeRange, currency, t);
      const serviceData = makeMonthlyTable(dataArray, ReportTablesMap.SERVICE, totalTimeRange.salonTotalServiceTimeRange, currency, t);
      const retailData = makeMonthlyTable(dataArray, ReportTablesMap.RETAIL, totalTimeRange.salonTotalRetailTimeRange, currency, t);
      const noshowData = makeMonthlyTable(dataArray, ReportTablesMap.NO_SHOW, totalTimeRange.salonTotalNoshowTimeRange, currency, t);

      return (
        <div className="revenue-monthly">
          <div className="bar-chart-container" style={{ width: this.chartWidth(), height: window.innerWidth < 600 ? 430 : 580 }}>
            {this.props.children}
            <BarChartD3
              width={this.chartWidth()}
              height={window.innerWidth < 600 ? 400 : 550}
              margin={{ top: 110, right: 5, bottom: 30, left: 65 }}
              chartData={revenueData.chartData}
              barTitle={t('businessReports.monthly.totalRevenueChartTitle', {
                selectedStylist: this.props.selectedStylist,
              })}
              barSubTitle={t('businessReports.monthly.totalRevenueChartSubTitle')}
              isFetching={this.props.isFetching}
              allDataLoaded={this.props.allDataLoaded}
              selectedStylist={this.props.selectedStylist}
            />
          </div>

          {dataArray.length > 0 && !this.props.isFetching && (
            <>
              {revenueData.leftHeader && revenueData.leftHeader.inputFields && revenueData.leftHeader.inputFields.length > 0 && (
                <ReportTableV2
                  data={revenueData}
                  title={`${t('businessReports.monthly.totalRevenueTableTitle', { selectedStylist: this.props.selectedStylist })}`}
                  startDate={formatDate(this.props.lastMonthlyDatesSelected.fromDate, {
                    hideTime: true,
                    hideWeekday: true,
                  })}
                  endDate={formatDate(this.props.lastMonthlyDatesSelected.toDate, {
                    hideTime: true,
                    hideWeekday: true,
                  })}
                />
              )}
              {serviceData.leftHeader && serviceData.leftHeader.inputFields && serviceData.leftHeader.inputFields.length > 0 && (
                <ReportTableV2
                  data={serviceData}
                  title={t('businessReports.monthly.serviceRevenueTableTitle', {
                    selectedStylist: this.props.selectedStylist,
                  })}
                  startDate={formatDate(this.props.lastMonthlyDatesSelected.fromDate, {
                    hideTime: true,
                    hideWeekday: true,
                  })}
                  endDate={formatDate(this.props.lastMonthlyDatesSelected.toDate, {
                    hideTime: true,
                    hideWeekday: true,
                  })}
                />
              )}
              {retailData.leftHeader && retailData.leftHeader.inputFields && retailData.leftHeader.inputFields.length > 0 && (
                <ReportTableV2
                  data={retailData}
                  title={t('businessReports.monthly.retailRevenueTableTitle', {
                    selectedStylist: this.props.selectedStylist,
                  })}
                  startDate={formatDate(this.props.lastMonthlyDatesSelected.fromDate, {
                    hideTime: true,
                    hideWeekday: true,
                  })}
                  endDate={formatDate(this.props.lastMonthlyDatesSelected.toDate, {
                    hideTime: true,
                    hideWeekday: true,
                  })}
                />
              )}
              {noshowData.leftHeader && noshowData.leftHeader.inputFields && noshowData.leftHeader.inputFields.length > 0 && (
                <ReportTableV2
                  data={noshowData}
                  title={t('businessReports.monthly.noShowRevenueTableTitle', {
                    selectedStylist: this.props.selectedStylist,
                  })}
                  startDate={formatDate(this.props.lastMonthlyDatesSelected.fromDate, {
                    hideTime: true,
                    hideWeekday: true,
                  })}
                  endDate={formatDate(this.props.lastMonthlyDatesSelected.toDate, {
                    hideTime: true,
                    hideWeekday: true,
                  })}
                />
              )}
            </>
          )}
        </div>
      );
    }
    return null;
  }
}

const mapStateToProps = (state) => ({
  salonId: state.currentSalon.id,
  lastDatesSelected: state.reports.lastDatesSelected,
  lastMonthlyDatesSelected: state.reports.lastMonthlyDatesSelected,
  currency: selectCurrentSalonCurrency(state),
});

const RevenueByStylistMonthlyTableHoc = connect(mapStateToProps)(withGilt(withTranslation()(RevenueByStylistMonthlyTable)));

export default RevenueByStylistMonthlyTableHoc;
